/**
 * @generated SignedSource<<788c75c4d9a5b4c716b75e342ac50f58>>
 * @relayHash 94c248943b3b0b0c03baff4ca1a110b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 996cb023111fa57f1dd082fe59c22577d0d79ed313ff735236b6e1b5890a1153

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiJWMAttachmentsQuery } from './uiJWMAttachmentsQuery.graphql';

const node: PreloadableConcreteRequest<uiJWMAttachmentsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "996cb023111fa57f1dd082fe59c22577d0d79ed313ff735236b6e1b5890a1153",
    "metadata": {},
    "name": "uiJWMAttachmentsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
